export class IRegisterSurveysData{
  state: string;
  name: string;
  description: string;
  url: string;
  user: string;
  constructor(def:any){
    this.state = def.state || "";
    this.name = def.name || "";
    this.description = def.description || "";
    this.url = def.url || "";
    this.user = def.user || "";
  }
}